<template>
  <div>
    <table class="export_table" id="export_table">
      <tr style="display: none">
        <th>no</th>
        <th>registryNum</th>
        <th>mobileNum</th>
        <th>asDesc</th>
      </tr>
      <tr>
        <th>No</th>
        <th>*가입번호</th>
        <th>*이동전화번호</th>
        <th>*처리사항</th>
      </tr>
      <tr :key="'excel_exp_' + index" v-for="(item, index) in list">
        <td>{{index + 1}}</td>
        <td>{{item.registryNum}}&#8203;</td>
        <td>{{item.mobileNum}}&#8203;</td>
        <td></td>
      </tr>
    </table>
  </div>
</template>

<script>
import xlsx from 'xlsx/xlsx'
import common from '../../script/common'

export default {
  props: ['exportData', 'asStep', 'filter'],
  data () {
    return {
      list: this.exportData,
      localFilter: this.filter
    }
  },
  mounted () {
    this.$emit('prepared')
  },
  watch: {
    exportData (newVal) {
      this.list = newVal.list
    }
  },
  methods: {
    download () {
      let mainData = xlsx.utils.table_to_sheet(document.getElementById('export_table'))
      let workBook = xlsx.utils.book_new()
      xlsx.utils.book_append_sheet(workBook, mainData, 'sheet1')
      let strToday = common.getFormattedDate(Date.now()).replaceAll('-', '')
      xlsx.writeFile(workBook, '모뎀AS_일괄등록_처리_' + strToday + '_' + this.localFilter.page + '.xlsx')
    }
  }
}
</script>

<style scoped>
.export_table {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/excel/ExcelDownloadModemASProgress.vue